import { Link } from "react-router-dom";
import Banner from "../../assets/Images/Banner.png"
import DocNavigation from "../../components/DocNavigation";

export default function Overview() {
    return (
        <div className="space-y-16">
            <div className="">
                <img src={Banner} className="w-full h-auto"/>
            </div>
            {/* HERO / INTRO */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    EventFlow Overview
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    EventFlow is a premium banquet and event management platform built to
                    bring elegance, structure, and control to your daily operations —
                    without complexity.
                </p>
            </section>

            {/* ABOUT EVENTFLOW */}
            <section className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="bg-[#C9A24E]/10 rounded-xl p-8">
                    <h2 className="text-xl font-semibold text-slate-900 mb-2">
                        About EventFlow
                    </h2>
                    <h3 className="text-md font-medium text-[#C9A24E] mb-4">
                        A Symphony of Grace &amp; Technology
                    </h3>

                    <p className="text-slate-700 leading-relaxed mb-4">
                        EventFlow is more than software — it is your operational partner in
                        creating unforgettable moments. Designed for marriage halls,
                        luxury banquets, and event venues, EventFlow transforms complex
                        operations into refined digital workflows.
                    </p>

                    <p className="text-slate-700 leading-relaxed">
                        From the first inquiry to the final settlement, every detail flows
                        with the same care and precision you bring to your celebrations.
                    </p>
                </div>

                {/* WHO IT IS FOR */}
                <div className="bg-white rounded-xl border border-slate-200 p-8">
                    <h3 className="text-xl font-semibold mb-4">
                        Built Specifically For
                    </h3>

                    <ul className="space-y-3 text-slate-600">
                        <li>• Marriage &amp; banquet halls</li>
                        <li>• Luxury event venues</li>
                        <li>• Operations &amp; front desk teams</li>
                        <li>• Accounts &amp; finance staff</li>
                    </ul>
                </div>
            </section>

            {/* PROBLEMS GRID */}
            <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-6">
                    What Problem Does EventFlow Solve?
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {[
                        "Double bookings and scheduling conflicts",
                        "Missed or incorrect payment tracking",
                        "Poor financial visibility",
                        "Operational stress during peak seasons",
                        "Disorganized historical records",
                        "Manual calculation and reporting errors",
                    ].map((item, i) => (
                        <div
                            key={i}
                            className="bg-white border border-slate-200 rounded-lg p-5 flex items-start gap-3"
                        >
                            <span className="mt-1 h-2.5 w-2.5 rounded-full bg-[#C9A24E]" />
                            <p className="text-slate-700">{item}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold text-slate-900 mb-6">
                    How EventFlow Works
                </h2>

                <ol className="grid grid-cols-1 md:grid-cols-2 gap-6 text-slate-700">
                    <li className="bg-white rounded-lg p-6 border border-slate-200">
                        <strong>1. Digital Bookings</strong>
                        <p className="mt-2 text-sm">
                            Record complete event details including date, portion, services,
                            and client information.
                        </p>
                    </li>

                    <li className="bg-white rounded-lg p-6 border border-slate-200">
                        <strong>2. Payment Tracking</strong>
                        <p className="mt-2 text-sm">
                            Track advances, dues, and final payments in real time.
                        </p>
                    </li>

                    <li className="bg-white rounded-lg p-6 border border-slate-200">
                        <strong>3. Calendar Control</strong>
                        <p className="mt-2 text-sm">
                            Prevent double bookings with a live availability calendar.
                        </p>
                    </li>

                    <li className="bg-white rounded-lg p-6 border border-slate-200">
                        <strong>4. Reports &amp; Insights</strong>
                        <p className="mt-2 text-sm">
                            Generate accurate operational and financial reports instantly.
                        </p>
                    </li>
                </ol>
            </section>

            {/* KEY CAPABILITIES */}
            <section>
                <h2 className="text-xl font-semibold text-slate-900 mb-6">
                    Key Capabilities
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ">
                    {[
                        "Centralized bookings",
                        "Live event calendar",
                        "Expense management",
                        "Supplier tracking",
                        "Professional invoices",
                        "Role-based access",
                        "Accurate reporting",
                        "Financial clarity",
                    ].map((cap, i) => (
                        <div
                            key={i}
                            className="bg-white border border-slate-200 rounded-lg p-4 text-sm text-slate-700 text-center hover:text-[#C9A24E]"
                        >
                            {cap}
                        </div>
                    ))}
                </div>
            </section>

            {/* NEXT STEP */}
            {/* NEXT STEP */}
            {/* <section className="border-t pt-8 mt-12">
                <p className="text-slate-600">
                    Next, learn how EventFlow is built by exploring the{" "}
                    <Link to="/docs/system-architecture" className="font-medium text-[#C9A24E]">
                        System Architecture
                    </Link>{" "}
                    section.
                </p>
            </section> */}
            
            <DocNavigation
                next={{
                    title: "System Architecture",
                    link: "/docs/system-architecture"
                }}
            />
        </div>
    );
}
